<div
  class="__wrapper mb-2"
  [class.is-disabled]="toggle.appearanceDisabled()"
  [class.pointer-events-none]="toggle.appearanceDisabled()"
  [ngClass]="base.styleClass()">
  @if (toggle.alignToFields()) {
    <!-- prázdný řádek popisku jako u polí (ui-input-wrapper) -->
    <span class="block" aria-hidden="true">&nbsp;</span>
  }
  <span
    class="__label inline-flex items-center gap-2"
    [class.ng-invalid]="control.invalid"
    [ngClass]="{ 'min-h-(--height-component-m)': toggle.alignToFields() }">
    <p-toggleswitch
      class="flex-none peer"
      [formControl]="control"
      (onChange)="handleChangeWrapper($event)"
      [falseValue]="toggle.falseValue()"
      [readonly]="base.readonly()"
      [class.p-toggleswitch-readonly]="base.readonly()"
      [trueValue]="true"
      [inputId]="randomInputId">
    </p-toggleswitch>
    @if (base.label) {
      <!-- jen pro čtení: popisek nereaguje na klik (kurzor přepínače nastavuje téma) -->
      <label class="m-0 cursor-pointer peer-[.p-toggleswitch-readonly]:cursor-default" [for]="randomInputId">{{
        base.label
      }}</label>
    }
    <ng-template
      [ngTemplateOutletContext]="{ item: toggle.customTemplateItem() }"
      [ngTemplateOutlet]="base.labelTemplate || defaultLabelTemplateRef">
    </ng-template>
  </span>
</div>
<ng-template #defaultLabelTemplateRef>
  @if (base.help) {
    <ui-form-field-help class="m-0" [help]="base.help"> </ui-form-field-help>
  }
</ng-template>
